export const APA_CALENDER_REQUEST = 'APA_CALENDER_REQUEST';
export const APA_CALENDER_SUCCESS = 'APA_CALENDER_SUCCESS';
export const APA_CALENDER_FAIL    = 'APA_CALENDER_FAIL';
